import { formatedPhoneNumber, unformatedPhoneNumber } from './phoneFormatter';

export default {
  displayFormat(value) {
    const numberLength = 9;
    const mask = '___-___-___';
    return formatedPhoneNumber(value, mask, numberLength);
  },

  modelFormat(valueToFormat) {
    const value = unformatedPhoneNumber(valueToFormat);
    return value;
  },
};
